import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContextMenuItemBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { useEntity } from '@backstage/plugin-catalog-react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { readCatalogInfoUrl } from './catalogInfoUrl';

const techneAboutCard = EntityCardBlueprint.make({
  name: 'techne-about',
  params: {
    type: 'info',
    filter: entity => {
      const kind = entity.kind.toLocaleLowerCase('en-US');
      return kind !== 'user' && kind !== 'group';
    },
    loader: async () => {
      const { TechneAboutCard } = await import('./TechneAboutCard');
      return <TechneAboutCard />;
    },
  },
});

const catalogInfoContextMenuItem = EntityContextMenuItemBlueprint.make({
  name: 'catalog-info',
  params: {
    icon: <DescriptionOutlinedIcon />,
    filter: entity => Boolean(readCatalogInfoUrl(entity)),
    useProps: () => {
      const { entity } = useEntity();
      const href = readCatalogInfoUrl(entity) ?? '#';
      return {
        title: 'catalog-info.yaml',
        href,
        disabled: href === '#',
      };
    },
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    techneAboutCard,
    catalogInfoContextMenuItem,
  ],
});
